/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Joi from 'joi-browser';

import { withStyles } from '@material-ui/core/styles';

import Form from '../../Form';
import { form as FormStyle } from '../../../style/form';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => FormStyle(typography, palette);

class ChangeEmailForm extends Form {
    state = {
        data: {
            newemail: '',
            confirmnewemail: '',
            currentemail: '',
        },
        errors: {},
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        this.props.fetchEmailAddress();
    };

    schema = {
        currentemail: Joi.string()
            .trim()
            .required()
            .label('Current Email'),
        newemail: Joi.string()
            .trim()
            .invalid(Joi.ref('currentemail'))
            .email({ minDomainSegments: 2 })
            .required()
            .label('New Email'),
        confirmnewemail: Joi.any()
            .valid(Joi.ref('newemail'))
            .required()
            .label('Confirm New Email'),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        if (props.newEmail) {
            const { data } = this.state;
            data.newemail = '';
            data.confirmnewemail = '';
            data.currentemail = props.newEmail;
            this.setState({ data });
        } else if (props.email) {
            const { data } = this.state;
            data.currentemail = props.email;
            this.setState({ data });
        }
    };

    doSubmit = (submitData) => {
        const { data } = this.state;
        submitData.handleChangeNewEmailAddress(data);
    };

    newEmailTemplate = (currentEmail) => (
        <>
            <p>To change your Email, please enter new Email twice.</p>
            <div className="margin-top-2x">
                <span className="bold">Current Email: </span>
                <span>{currentEmail}</span>
            </div>
        </>
    );

    handleNewEmailChange = (dataChanged) => {
        const data = { ...dataChanged };
        let { errors } = this.state;
        if (data.newemail === data.currentemail) {
            errors = {
                newemail: 'Please enter new Email.',
            };
            this.setState({ errors });
        } else if (data.newemail !== data.confirmnewemail) {
            errors = {
                confirmnewemail: 'Please enter the same Email.',
            };
            this.setState({ errors });
        } else {
            delete errors.newemail;
            delete errors.confirmnewemail;
            this.setState({ errors });
        }
    };

    updatedEmailTempate = (currentEmail) => (
        <>
            <p>
                <span className="bold">Congratulations!</span> You have updated
                your email.
            </p>
            <div className="margin-top-2x margin-bottom-2x">
                <span className="bold">New Email: </span>
                <span>{currentEmail}</span>
            </div>
            <p>To change your Email, please enter new Email twice.</p>
        </>
    );

    changeEmailForm = (classes, isReadyState, submitData) => (
        <>
            <form
                onSubmit={(event) => this.handleSubmit(event, submitData)}
                className={`${classes.form} row margin-top-2x padding-bottom-2x`}
                disabled={!isReadyState}
            >
                {this.renderInput({
                    name: 'newemail',
                    label: 'New Email',
                    type: 'email',
                    length: 50,
                    onChangeHandler: this.handleNewEmailChange,
                })}
                {this.renderInput({
                    name: 'confirmnewemail',
                    label: 'Confirm New Email',
                    type: 'email',
                    length: 50,
                })}
                <div className="margin-top-2x margin-bottom-2x opacity1">
                    {this.renderButton({
                        label: isReadyState ? 'Update Email' : 'Updating Email...',
                        className: 'buttonHD',
                        onClick: null,
                        type: 'submit',
                        isValidated: true,
                        isReadyState,
                    })}
                </div>
            </form>
        </>
    );

    handleContinueShoppingClicked = () => {
        this.props.history.push('/');
    };

    render() {
        const {
            classes,
            isReadyState,
            email,
            newEmail,
            handleChangeNewEmailAddress,
        } = this.props;
        const submitData = { handleChangeNewEmailAddress };
        const currentEmail = newEmail || email;
        return (
            <>
                {!newEmail
                    ? this.newEmailTemplate(currentEmail)
                    : this.updatedEmailTempate(currentEmail)}
                {this.changeEmailForm(classes, isReadyState, submitData)}
            </>
        );
    }
}

ChangeEmailForm.defaultProps = {
    email: '',
};

ChangeEmailForm.propTypes = {
    classes: PropTypes.object.isRequired,
    email: PropTypes.string,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        email: newState.email,
        newEmail: newState.newEmail,
        toggleState: newState.toggleState,
        error: newState.error,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchEmailAddress: () => dispatch(EventDispatcher.fetchEmailAddress()),
    handleChangeNewEmailAddress: (data) => dispatch(EventDispatcher.handleChangeNewEmailAddress(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(ChangeEmailForm)));
